import { TOPBAR_HEIGHT } from '@capsicum/common-web';
import { HeaderWarning } from '@capsicum/features/regulations/web';
import styled from 'styled-components';

export const WCPledgeHeaderWarning = styled(HeaderWarning)`
	position: sticky;
	top: ${TOPBAR_HEIGHT}px;
	z-index: 101;
	width: 100%;
	background-color: transparent;
	padding-top: ${({ theme }) => theme.spacings.xsmall};
`;
